import { ofType } from 'redux-observable';
import { mergeMap, map, filter } from 'rxjs';
import { AppEpic } from 'src/store';
import { of } from 'rxjs';
import {
  inputIsNotNullOrUndefined,
  isSameComponentType,
  isScopeDefined,
  isSubheaderLoaded,
  maybeGetComponentProps,
  topMemInWorklistSelected,
} from 'src/utils/Functions/epicsFunctions';
import { ConfDefnComponentType, type ListViewComponent } from 'configuration-schemas/confdefnComponents';
import { cleanUp, fetchListViewData, receiveConfig } from './ListView.slice';
import { isNil } from 'lodash';
import { ExtraPivotOptions, getAggBys, organizeListDataOptions } from '../../StyleColorReview/StyleColorReview.slice';
import { isListDataApi } from 'configuration-schemas/confdefnView';
import { updateFlowStatus } from 'src/components/Subheader/Subheader.slice';
import {
  receiveScopeConfig,
  receiveScopeRefreshTrigger,
} from 'src/components/AssortmentScopeSelector/AssortmentScopeSelector.slice';
import { receiveFilterStateAfterSubmission } from 'src/components/FilterPanel/FilterPanel.slice';
import { updateSelectedItem } from 'src/pages/Worklist/Worklist.slice';
import { setActivePage, setActiveSubPage } from 'src/pages/NavigationShell/NavigationShell.slice';
import { LENS_ASST_PLAN_REFRESHING_PAGE } from 'src/pages/AssortmentBuild/Planning.types';

export const listViewLoad: AppEpic = (action$, state$) => {
  return action$.pipe(
    ofType(
      receiveScopeRefreshTrigger.type,
      receiveFilterStateAfterSubmission.type,
      setActivePage.type,
      setActiveSubPage.type,
      updateSelectedItem.type,
      updateFlowStatus.type,
      receiveConfig.type,
      receiveScopeConfig.type,
      LENS_ASST_PLAN_REFRESHING_PAGE,
    ),
    map(() => maybeGetComponentProps<ListViewComponent>(state$.value, ConfDefnComponentType.listView)),
    filter(inputIsNotNullOrUndefined),
    filter(() => topMemInWorklistSelected(state$.value)),
    filter(() => isScopeDefined(state$.value.scope) && isSubheaderLoaded(state$.value.subheader)),
    mergeMap(({ defns, topMembers }) => {
      const { dataApi, model: modelDefn } = defns;
      const finalModelDefn = isListDataApi(dataApi) ? dataApi.defnId : modelDefn;

      const flowStatus = state$.value.subheader.flowStatus.join(',');
      const aggBy = getAggBys(state$.value.subheader, dataApi, { forceReload: true });
      const options: ExtraPivotOptions = !isNil(topMembers) ? { topMembers, flowStatus, aggBy } : { flowStatus, aggBy };
      const finalOptions = organizeListDataOptions(options, dataApi);

      if (isSameComponentType<ListViewComponent>(state$.value, ConfDefnComponentType.listView)) {
        return of(cleanUp(), fetchListViewData(finalModelDefn, finalOptions));
      }

      return of(fetchListViewData(finalModelDefn, finalOptions));
    }),
  );
};
